<script>
export default {
  props: ['formdata'],
  data() {
    return {
      localModel: {},
      initial:true,
    }
  },
  methods: {
    previousStep() {
      this.emitter.emit("step", 1);
    },
    nextStep() {
      this.initial = false
      if (this.validate()) {
        this.emitter.emit("modelUpdated", this.localModel);
        this.emitter.emit("step", 3);
      }

    },
    validate() {
      if (this.localModel.company === "" ||
          this.localModel.street === "" ||
          this.localModel.housenumber === "" ||
          this.localModel.zipcode === "" ||
          this.localModel.city === "" ||
          this.localModel.country === ""
      )
        return false;
      return true;
    },
  },

  mounted() {
    this.localModel = this.formdata;
  }
}
</script>

<template>

  <!------------ step form Area Start  ----------->
  <section class="step-form">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="step-form-wrapper">
            <div class="contact-form">
              <form action="">
                <div class="step-form-content">
                  <form action="data.php" method="post" class="form">
                    <!-- Progress Bar -->
                    <div class="progress-bar">
                      <div class="progress" id="progress"></div>
                      <div class="progress-step active" data-title="Personal"></div>
                      <div class="progress-step active" data-title="Contact "></div>
                      <div class="progress-step" data-title="Experiences"></div>
                      <div class="progress-step" data-title="Links"></div>
                    </div>

                    <!-- Steps -->
                    <div class="form-step active">
                      <h3>Bedrijfsgegevens</h3>
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="contact-form-info">
                                <label for="">Bedrijfsnaam*</label>
                                <input type="text" v-model="localModel.company"
                                       :class="localModel.company === '' && initial === false  ? 'invalid' : ''"
                                       placeholder="Bedrijfsnaam">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6">
                              <div class="contact-form-info">
                                <label for="">Straat*</label>
                                <input type="text" v-model="localModel.street"
                                       :class="localModel.street === '' && initial === false  ? 'invalid' : ''"
                                       placeholder="Straatnaam">
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <div class="contact-form-info">
                                <label for="">Huisnummer*</label>
                                <input type="text" v-model="localModel.housenumber"
                                       :class="localModel.housenumber === '' && initial === false  ? 'invalid' : ''"
                                       placeholder="Huisnummer">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6">
                              <div class="contact-form-info">
                                <label for="">Postcode*</label>
                                <input type="text" v-model="localModel.zipcode"
                                       :class="localModel.zipcode === '' && initial === false  ? 'invalid' : ''"
                                       placeholder="1234AB">
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <div class="contact-form-info">
                                <label for="">Plaats*</label>
                                <input type="text" v-model="localModel.city"
                                       :class="localModel.city === '' && initial === false  ? 'invalid' : ''"
                                       placeholder="Plaats">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="contact-form-info">
                                <label for="">Land*</label>
                                <select v-model="localModel.country"

                                        :class="localModel.country === '' && initial === false  ? 'invalid' : ''"
                                >
                                  <option value="" disabled selected hidden>Kies je land</option>
                                  <option value="NL">Nederland</option>
                                  <option value="BE">België</option>
                                  <option value="DE">Duitsland</option>
                                  <option value="FR">Frankrijk</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="contact-form-btn contact-form-btn-two">
                  <button class="contact-form-btn-gray" @click.prevent="previousStep()">Vorige</button>
                  <button @click.prevent="nextStep()">Volgende</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!------------ step form Area End ------------->


</template>

<style scoped>
select {
  width: 100%;
  padding: 0 15px;
  height: 44px;
  font-size: 12px;
  border: 1px solid #C6C7D3;
  color: #1A2050;
  font-weight: 400;
  border-radius: 4px;
  background-color: #fff;
  line-height: 12px;
}
</style>